var render, staticRenderFns
import script from "./AdsFilter.vue?vue&type=script&lang=js"
export * from "./AdsFilter.vue?vue&type=script&lang=js"
import style0 from "./AdsFilter.vue?vue&type=style&index=0&id=1c8397bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8397bf",
  null
  
)

export default component.exports